// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'vant/lib/index.css'
import global from './components/Global.vue'
import {
    Button,
    Form,
    CellGroup,
    Field,
    RadioGroup,
    Radio,
    DropdownMenu,
    DropdownItem,
    Popup,
    Tabs,
    Tab,
    List,
    PullRefresh,
    Dialog,
    Cell,
    Icon,
    ContactCard,
    Checkbox,
    Toast,
} from 'vant'
Vue.use(Button)
    .use(Form)
    .use(CellGroup)
    .use(Field)
    .use(RadioGroup)
    .use(Radio)
    .use(DropdownMenu)
    .use(DropdownItem)
    .use(Popup)
    .use(Tabs)
    .use(Tab)
    .use(List)
    .use(PullRefresh)
    .use(Dialog)
    .use(Cell)
    .use(Icon)
    .use(ContactCard)
    .use(Checkbox)
    .use(Toast);

Vue.config.productionTip = false;
Vue.prototype.GLOBAL = global;

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
        next();
    } else
        next();
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js